import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import NodeUserInfoAPIs from '../node-user-info';
import { getSafeData } from '../utils';
import { applySorting, isDuplicateQuestion } from './utils';
function getSearchQuery(filters) {
    return db.qnaNode
        .where('ancestors')
        .equals(filters.ancestorID || '')
        .and(node => {
        const isQuestionType = [NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(node.type);
        if (!isQuestionType || node.deleted)
            return false;
        if (filters.includeDuplicates !== true && isDuplicateQuestion(node))
            return false;
        // Apply filters
        if (typeof filters.answered === 'boolean') {
            if (node.attributes?.answered !== filters.answered)
                return false;
        }
        if (typeof filters.query === 'string' && filters.query.trim().length > 0) {
            const questionText = node.data.question || '';
            const searchText = questionText.toLowerCase();
            if (!searchText.includes(filters.query.trim().toLowerCase()))
                return false;
        }
        return true;
    });
}
export const search = async (userID, filters, pagination = { offset: 0 }) => {
    const { offset = 0, limit = 20 } = pagination;
    const query = getSearchQuery(filters);
    // Get all questions that match the base filters (without read/bookmarked)
    let baseQuestions = await query.toArray();
    // Apply read/bookmarked filters if specified
    if (typeof filters.read === 'boolean' || typeof filters.bookmarked === 'boolean') {
        const userDataList = await NodeUserInfoAPIs.getAllUserData(userID);
        const userDataMap = new Map(userDataList.map(item => [item.questionID, item.userData]));
        baseQuestions = baseQuestions.filter(q => {
            const userData = userDataMap.get(q._id) || {};
            if (filters.read !== undefined && Boolean(userData.read) !== filters.read)
                return false;
            if (filters.bookmarked !== undefined && Boolean(userData.bookmarked) !== filters.bookmarked)
                return false;
            return true;
        });
    }
    // Calculate total count from the filtered questions
    const totalCount = baseQuestions.length;
    // Apply sorting to all questions first (before pagination)
    const sortedQuestions = await applySorting(userID, baseQuestions, filters.sortBy);
    // Apply pagination to get the final list
    const paginatedQuestions = sortedQuestions.slice(offset, offset + limit);
    return {
        list: paginatedQuestions.map(getSafeData),
        totalCount,
    };
};
